<div class="panel-firmantes-unificado">
  <ng-container *ngIf="!mostrarTiposContenido">
    <div class="info">
      <h2>Firmantes y campos</h2>
      <p>Configura firmas, formularios y campos editables por firmante. Arrastra los elementos al documento.</p>
    </div>

    <p class="panel-firmantes-unificado__vacio" *ngIf="mostrarFirmantes.length === 0">
      No hay firmantes seleccionados. Configura la identificación en el paso anterior.
    </p>

    <div class="panel-firmantes-unificado__lista">
      <app-panel-firmante-card
        *ngFor="let firmante of mostrarFirmantes; trackBy: trackByCodigo"
        [firmanteUi]="firmante"
        [tipoFirmante]="firmante.tipoFirmante"
        [accionActiva]="getAccionActiva(firmante.tipoFirmante.codigo)"
        [esPrimerFirmante]="firmante.tipoFirmante?.codigo === codigoFirmantePrincipal"
        [tiposContenidoOverlayActivo]="mostrarTiposContenido && firmante.tipoFirmante?.codigo === codigoFirmantePrincipal"
        [mostrarLimpiar]="firmantePuedeLimpiarse(firmante)"
        (toggleExpand)="toggleExpand($event)"
        (accionChange)="onAccionChange(firmante.tipoFirmante.codigo, $event)"
        (firmanteSeleccionado)="onFirmanteSeleccionado($event)"
        (tiposContenidoChange)="onTiposContenidoChange($event)"
        (quitarFirmante)="quitarFirmante($event)"
        (limpiarEnDocumento)="limpiarFirmanteEnDocumento($event)">
      </app-panel-firmante-card>
    </div>

    <button
      *ngIf="modoEnvioSimple"
      class="panel-firmantes-unificado__anadir"
      type="button"
      [disabled]="!puedeAnadirFirmante"
      (click)="anadirFirmante()">
      <svg class="panel-firmantes-unificado__anadir-icon"><use xlink:href="#icon-plus"></use></svg>
      Añadir firmante
    </button>
  </ng-container>

  <div *ngIf="mostrarTiposContenido" class="panel-firmantes-unificado__tipos-contenido">
    <app-configuracion-documento-incluir-contenido
      [overlayMode]="true"
      (cerrar)="cerrarTiposContenido()">
    </app-configuracion-documento-incluir-contenido>
  </div>
</div>
